import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import MuiIconButton from '@material-ui/core/IconButton';

import Tooltip from 'components/common/Tooltip';

const styles = theme => ({
  tooltip: {
    color: theme.palette.grey[600],
    width: 48,
    height: 48,
  },
  button: {
    color: 'inherit',
    width: '100%',
    height: '100%',
  },
  label: {
    position: 'relative',
  },
});

const IconButton = ({
  className,
  href,
  staticContext,
  onClick,
  history,
  tooltipContent,
  tooltipPlacement,
  target,
  tooltipColor,
  classes,
  ...otherProps
}) => {
  const button = (
    <MuiIconButton
      {...!tooltipContent ? { className } : { className: classes.button }}
      {...href && staticContext ? { href } : {}}
      classes={{
        label: classes.label,
      }}
      target={target}
      onClick={href && target !== '_blank'
        ? (event) => {
          event.preventDefault();
          onClick();
          if (href !== history.location.pathname) {
            history.push(href);
          }
        }
        : (event) => {
          if (target !== '_blank') {
            event.preventDefault();
          }
          onClick(event);
        }
      }
      {...otherProps}
    />
  );
  if (tooltipContent) {
    return (
      <Tooltip
        className={classNames(classes.tooltip, className)}
        content={tooltipContent}
        placement="top"
        color={tooltipColor}
        disableGutters
        {...tooltipPlacement ? { placement: tooltipPlacement } : {}}
      >
        {button}
      </Tooltip>
    );
  }
  return button;
};

IconButton.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string,
  staticContext: PropTypes.bool,
  onClick: PropTypes.func,
  tooltipContent: PropTypes.node,
  tooltipPlacement: PropTypes.oneOf([
    'bottom-end',
    'bottom-start',
    'bottom',
    'left-end',
    'left-start',
    'left',
    'right-end',
    'right-start',
    'right',
    'top-end',
    'top-start',
    'top',
  ]),
  tooltipColor: PropTypes.oneOf(['white', 'grey', 'dark']),
  target: PropTypes.oneOf(['_blank', '_self']),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    tooltip: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
  }).isRequired,
};

IconButton.defaultProps = {
  className: '',
  href: null,
  staticContext: true,
  tooltipContent: null,
  onClick: () => {},
  target: '_self',
  tooltipPlacement: null,
  tooltipColor: 'dark',
};

export default withRouter(withStyles(styles)(IconButton));



// WEBPACK FOOTER //
// ./src/components/common/IconButton.js